import React from 'react';
const fmt = value => '₦' + Number(value || 0).toLocaleString('en-NG');

export default function RefundCollectionSummary({ collections, unallocated }) {
  if (!collections) return null;
  return <div style={{marginBottom:20}}>
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))',gap:12}}>
      {[
        ['Customer receipts',collections.gross_receipts,'#556B2F'],
        ['Customer refunds',collections.refunds_paid,'#8F2E24'],
        ['Net customer receipts',collections.net_receipts,Number(collections.net_receipts)<0?'#8F2E24':'#2E6B3A']
      ].map(([label,value,color]) => <div key={label} style={{background:'#F2EFE7',borderRadius:8,padding:14}}>
        <div style={{fontSize:12,fontWeight:700,color}}>{label}</div>
        <div style={{fontSize:22,fontWeight:700,color,marginTop:6}}>{fmt(value)}</div>
      </div>)}
    </div>
    <p style={{fontSize:12,margin:'8px 0 0',color:'#3B2A21'}}>Receipts and refunds use their payment dates. Net receipts can be negative when an earlier payment is refunded in this period.</p>
    {Number(unallocated?.count || 0)>0 && <div style={{background:'#FFF3DC',padding:12,borderRadius:8,marginTop:12,fontSize:12,color:'#6B4800'}}>
      {Number(unallocated.count)} historical refund outflow(s), totalling {fmt(unallocated.amount)}, have no named paying account. They are included in cash-flow totals. Individual account balances need that allocation.
    </div>}
  </div>;
}
